module.exports = __webpack_public_path__ + "img/image_02.a64cf5c1.png";